import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { SOCIAL_LINKS } from '../data/config';

const WhatsAppFloat = () => {
  if (!SOCIAL_LINKS.whatsapp) return null;
  return (
    <motion.a
      href={SOCIAL_LINKS.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, type: 'spring', stiffness: 260, damping: 18 }}
      className="fixed bottom-24 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-card-hover transition-transform duration-200 hover:scale-110 md:bottom-6 md:right-6"
      data-testid="whatsapp-float"
      aria-label="Chat with us on WhatsApp"
    >
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" />
      <MessageCircle className="h-6 w-6" />
    </motion.a>
  );
};

export default WhatsAppFloat;
